import { render, staticRenderFns } from "./IdealerassignvehicleRetransfer.vue?vue&type=template&id=2008965a&scoped=true"
import script from "./IdealerassignvehicleRetransfer.vue?vue&type=script&lang=js"
export * from "./IdealerassignvehicleRetransfer.vue?vue&type=script&lang=js"
import style0 from "./IdealerassignvehicleRetransfer.vue?vue&type=style&index=0&id=2008965a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2008965a",
  null
  
)

export default component.exports